//@import dependencies
import React, {useState, useEffect} from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
//@end

//@import components
import TinyEditorComponent from 'app_components/commons/tinyEditor';
import SchedulingFormModule from 'app_components/modules/admin/landings/schedulingForm/index';
import IconComponent from 'app_components/commons/icons'
import AlertComponent from 'app_components/commons/alert'
import ModalTrainingFormModule from 'app_components/modules/admin/landings/modalTrainingForm'
//@end

// @import hooks
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useColors } from 'app_hooks/useColors'
// @end

// @INFO Import types
import { ILanding } from 'app_types/admin/landings/landingTypes'
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../officialslandingModule.scss'

// @ADD Component types
interface IOfficialslandingModuleLayoutProps {
  permission: any
  landingInfo: ILanding | null
  loadingForm: 'loading' | null
  onHandleSchedulingSubmit: (data: any) => void | null
  onHandleGeneralInfoSubmit: (data: any) => void | null
  onHandleTrainingSubmit: (data: any) => void | null
  onHandleArticleSubmit: (data: any) => void | null
  onHandleTrainingRemove: (data: any) => void | null
}

const OfficialslandingModuleLayout: React.FC<IOfficialslandingModuleLayoutProps> = (props) => {

  const [colors] = useColors()
  const generalInfoFormHook = useForm()
  const articleFormHook = useForm()
  const [tinyData, updateTinyData] = useState<any>('')
  const [resetTiny, updateResetTiny] = useState<boolean>(false)
  const [trainingEditData, setTrainingEditData] = useState<any>(null)
  const [modalTrainingFormStatus, setModalTrainingFormStatus] = useState<boolean>(false)
  const [listOfTrainings, setListOfTrainings] = useState<Array<any>>([])
  const { t } = useTranslation()

  const [listOfSchedulings, setListOfSchedulings] = useState<Array<any>>([])

  useEffect(() => {
    let schedulings: Array<any> = []
    if (props.landingInfo?.landing?.scheduling && props.landingInfo?.landing?.scheduling.length > 0) {
      schedulings = props.landingInfo?.landing?.scheduling
    }
    setListOfSchedulings(schedulings)
  }, [props.landingInfo?.landing?.scheduling])

  useEffect(() => {
    let trainings: Array<any> = []
    if (props.landingInfo?.landing?.trainings && props.landingInfo?.landing?.trainings.length > 0) {
      trainings = props.landingInfo?.landing?.trainings
    }
    setListOfTrainings(trainings)
  }, [props.landingInfo?.landing?.trainings])

  useEffect(() => {
    if(props?.landingInfo?.landing?.article?.content){
      updateTinyData(props?.landingInfo?.landing?.article?.content)
      updateResetTiny(true)
      setTimeout(() => {
        updateResetTiny(false)
      }, 10)
    }
  }, [props?.landingInfo?.landing?.article?.content])

  const handleSubmitArticle = (_data: any) => {
    const data = {
      article: {
        ..._data.article,
        content: tinyData
      }
    }
    props.onHandleArticleSubmit(data)
  }

  // @INFO: Metodos para capacitaciones
  const handleOpenModalTraining = () => {
    setModalTrainingFormStatus(true)
  }

  const handleCloseModalTraining = async (data: any) => {
    setTrainingEditData(null)
    setModalTrainingFormStatus(false)
    if (data?.status === true && data?.data) {
      props.onHandleTrainingSubmit({status: 'success'})
    }
  }

  const editTraining = (training: number) => {
    setTrainingEditData(training)
    setModalTrainingFormStatus(true)
  }
  const removeTraining = (unique: string) => {
    props.onHandleTrainingRemove(unique)
  }

  return(
    <div className='officials_landing_module-layout'>
      <div className="d-flex align-items-center mb-2">
        <h3 className="form-title">{t("modules.teacher_landing_form.sections.general_information")}</h3>
      </div>

      <form
        onSubmit={generalInfoFormHook.handleSubmit(props.onHandleGeneralInfoSubmit)}
        className="form-general-info"
      >
        <div className="row">
          <div className="col-8">
            <div className='form-group '>
              <label htmlFor='title_page'>{t('labels.teacher_landing_form.title_page')}</label>
              {generalInfoFormHook.errors.title_page && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              <input
                id='title_page'
                name='title_page'
                className={`form-control ${generalInfoFormHook.errors.title_page && 'is-invalid'}`}
                type='text'
                ref={generalInfoFormHook.register({ required: true })}
                defaultValue={props?.landingInfo?.landing?.title_page}
              />
            </div>
          </div>
          {props.permission.checkSimple('permission:landings_officials_general_info') && (
            <div className="col-4 button-right">
              <button className='btn btn-primary button-with-spinner' type='submit' disabled={props.loadingForm === 'loading'}>
                {props.loadingForm === 'loading' && (
                  <>
                    <div className="spinner-border spinner-loading-button" role="status"></div>&nbsp;&nbsp;
                  </>
                )}
                {t('buttons.save')}
              </button>
            </div>
          )}
        </div>
      </form>

      <div className="d-flex align-items-center mb-2">
        <h3 className="form-title">{t("modules.teacher_landing_form.sections.trainings")}</h3>
      </div>

      <form
        onSubmit={generalInfoFormHook.handleSubmit(props.onHandleGeneralInfoSubmit)}
        className="form-general-info"
      >
        <div className="row">
          <div className="col-8">
            <div className='form-group '>
              <label htmlFor='title_training'>{t('labels.teacher_landing_form.title_training')}</label>
              {generalInfoFormHook.errors.title_training && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              <input
                id='title_training'
                name='title_training'
                className={`form-control ${generalInfoFormHook.errors.title_training && 'is-invalid'}`}
                type='text'
                ref={generalInfoFormHook.register({ required: true })}
                defaultValue={props?.landingInfo?.landing?.title_training}
              />
            </div>
          </div>
          {props.permission.checkSimple('permission:landings_officials_training') && (
            <div className="col-4 button-right">
              <button className='btn btn-primary button-with-spinner' type='submit' disabled={props.loadingForm === 'loading'}>
                {props.loadingForm === 'loading' && (
                  <>
                    <div className="spinner-border spinner-loading-button" role="status"></div>&nbsp;&nbsp;
                  </>
                )}
                {t('buttons.save')}
              </button>
            </div>
          )}
        </div>
      </form>

      <div className="row">
        {props.permission.checkSimple('permission:landings_officials_training') && (
          <div className="col-12 text-right mb-3">
            <button className="btn btn-primary" onClick={handleOpenModalTraining} type="button">
              <IconComponent fontawesome={{icon: 'fa fa-plus'}} />&nbsp;&nbsp;
              {t("modules.teacher_landing_form.training.add")}
            </button>
          </div>
        )}
        {listOfTrainings.length > 0 ? (
          <>
            {listOfTrainings.map((training, index) => (
              <div className="col-12">
                <div className="training-item">
                  <div className="training-content">
                    <div>
                      <b>{t("modules.teacher_landing_form.training.list.status")}:</b> {(training.status === true) ? `${t("labels.enabled")}` : `${t("labels.disabled")}`}
                    </div>
                    <div>
                      <b>{t("modules.teacher_landing_form.training.list.course")}:</b> {training?.course?.program?.name}
                    </div>
                    {/* <div>
                      <b>{t("modules.teacher_landing_form.training.list.title")}:</b> {training.title}
                    </div>
                    <div>
                      <b>{t("modules.teacher_landing_form.training.list.description")}:</b> {training.description}
                    </div>
                    <div>
                      <b>{t("modules.teacher_landing_form.training.list.modality")}:</b> {training.modality}
                    </div>
                    {training.price && (
                      <div>
                        <b>{t("modules.teacher_landing_form.training.list.price")}:</b> {parseFloat(training.price).toLocaleString('es-CO', {style: 'currency', currency: 'COP'})}
                      </div>
                    )}
                    {training.url_video && (
                      <div>
                        <b>{t("modules.teacher_landing_form.training.list.video")}:</b> <a href={training.url_video} target="__blank" rel="noopener noreferrer" >Enlace</a>
                      </div>
                    )} */}
                    {/* <div>
                      <b>{t("modules.teacher_landing_form.training.list.city")}:</b> {training.city}
                    </div> */}
                    {/* <div>
                      <b>{t("modules.teacher_landing_form.training.list.start_date")}:</b> {(training.start_date ? training.start_date.replace('T00:00:00.000Z','') : '')}
                    </div> */}
                    {/* {training.attachedFile && (
                      <div>
                        <b>{t("modules.teacher_landing_form.training.list.attached")}:</b> <a href={training.attachedFile} target="__blank" rel="noopener noreferrer" >Descarga aqui</a>
                      </div>
                    )} */}
                    {/* <div>
                      <b>{t("modules.teacher_landing_form.training.list.publication_date")}:</b> {training.publication_date}
                    </div> */}
                  </div>
                  <div className="training-actions">
                    {props.permission.checkSimple('permission:landings_officials_training') && (
                      <>
                        <OverlayTrigger
                          trigger={['hover', 'focus']}
                          placement={'top'}
                          overlay={
                            <Tooltip id='toolip-circle'>
                              {t("modules.teacher_landing_form.training.edit")}
                            </Tooltip>
                          }>
                            <div className="session-action" onClick={() => editTraining(training)}>
                              <IconComponent fontawesome={{icon: 'fas fa-edit'}} color={colors.primary} />
                            </div>
                        </OverlayTrigger>
                        &nbsp;&nbsp;
                        <OverlayTrigger
                          trigger={['hover', 'focus']}
                          placement={'top'}
                          overlay={
                            <Tooltip id='toolip-circle'>
                              {t("modules.teacher_landing_form.training.delete")}
                            </Tooltip>
                          }>
                            <div className="session-action" onClick={() => removeTraining(training.unique)}>
                              <IconComponent fontawesome={{icon: 'fas fa-trash-alt'}} color={colors.primary} />&nbsp;&nbsp;
                            </div>
                        </OverlayTrigger>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : (
          <div className="col-12">
            <AlertComponent
              type='warning'
              title={t('modules.teacher_landing_form.training.no_data')}
            />
          </div>
        )}

      </div>


      <div className="d-flex align-items-center mb-2">
        <h3 className="form-title">{t("modules.teacher_landing_form.sections.article")}</h3>
      </div>

      <form onSubmit={articleFormHook.handleSubmit(handleSubmitArticle)} className="form-article mb-3">
        <div className="row">
          <div className="col-md-12">
            <div className="row">
              <div className="col-6">
                <div className='form-group'>
                  <label htmlFor='article[cover]'>{t('labels.teacher_landing_form.article.cover')}</label>
                  {articleFormHook.errors?.article?.cover && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  <input
                    id='article[cover]'
                    name='article[cover]'
                    className='form-control-file'
                    type='file'
                    ref={articleFormHook.register({ required: false })}
                  />
                  {articleFormHook.errors?.article?.cover && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                </div>
              </div>
              {props?.landingInfo?.landing?.article?.coverFile && (
                <>
                  <input type="hidden" name="article[coverUrl]" value={props?.landingInfo?.landing?.article?.coverUrl} ref={articleFormHook.register({ required: true })} />
                  <div className="col-md-6">
                    <div className="form-group">
                        <div className="cover-container">
                          <img src={props?.landingInfo?.landing?.article?.coverFile} alt=""/>
                        </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label htmlFor='article[coverCaption]'>{t('labels.teacher_landing_form.article.coverCaption')}</label>
              {articleFormHook.errors?.article?.coverCaption && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              <input
                id='article[coverCaption]'
                name='article[coverCaption]'
                className={`form-control ${articleFormHook.errors?.article?.coverCaption && 'is-invalid'}`}
                type='text'
                ref={articleFormHook.register({ required: false })}
                defaultValue={props?.landingInfo?.landing?.article?.coverCaption}
              />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label htmlFor='article[title]'>{t('labels.teacher_landing_form.article.title')}</label>
              {articleFormHook.errors?.article?.title && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              <input
                id='article[title]'
                name='article[title]'
                className={`form-control ${articleFormHook.errors?.article?.title && 'is-invalid'}`}
                type='text'
                ref={articleFormHook.register({ required: true })}
                defaultValue={props?.landingInfo?.landing?.article?.title}
              />
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label htmlFor='sdfasdf'>{t('labels.teacher_landing_form.article.content')}</label>
              {!resetTiny ?
                <TinyEditorComponent
                  data={tinyData}
                  onChange={(content) => updateTinyData(content)}
                />
              :null}
            </div>
          </div>

          {props.permission.checkSimple('permission:landings_officials_article') && (
            <div className="col-12 text-right">
              <button className='btn btn-primary button-with-spinner' type='submit' disabled={props.loadingForm === 'loading'}>
                {props.loadingForm === 'loading' && (
                  <>
                    <div className="spinner-border spinner-loading-button" role="status"></div>&nbsp;&nbsp;
                  </>
                )}
                {t('buttons.save')}
              </button>
            </div>
          )}
        </div>
      </form>

      <div className="d-flex align-items-center mb-2">
        <h3 className="form-title">{t("modules.teacher_landing_form.sections.post")}</h3>
      </div>

      <form
        onSubmit={generalInfoFormHook.handleSubmit(props.onHandleGeneralInfoSubmit)}
        className="form-general-info"
      >
        <div className="row">
          <div className="col-8">
            <div className='form-group '>
              <label htmlFor='title_posts'>{t('labels.teacher_landing_form.title_posts')}</label>
              {generalInfoFormHook.errors.title_posts && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              <input
                id='title_posts'
                name='title_posts'
                className={`form-control ${generalInfoFormHook.errors.title_posts && 'is-invalid'}`}
                type='text'
                ref={generalInfoFormHook.register({ required: true })}
                defaultValue={props?.landingInfo?.landing?.title_posts}
              />
            </div>
          </div>
          {/* {props.permission.checkSimple('permission:landings_officials_training') && ( */}
            <div className="col-4 button-right">
              <button className='btn btn-primary button-with-spinner' type='submit' disabled={props.loadingForm === 'loading'}>
                {props.loadingForm === 'loading' && (
                  <>
                    <div className="spinner-border spinner-loading-button" role="status"></div>&nbsp;&nbsp;
                  </>
                )}
                {t('buttons.save')}
              </button>
            </div>
          {/* )} */}
        </div>
      </form>

      {/* ========== Programación en linea =============== */}
      <SchedulingFormModule
        source='officials'
        listOfSchedulings={listOfSchedulings}
        onHandleSchedulingSubmit={props.onHandleSchedulingSubmit}
      />

      {modalTrainingFormStatus && (
        <ModalTrainingFormModule
          source='officials'
          open={modalTrainingFormStatus}
          handleClose={handleCloseModalTraining}
          editData={trainingEditData}
          fields={
            ['course']
            // ['modality', 'price', 'video']
          }
        />
      )}
    </div>
  )
}

export default OfficialslandingModuleLayout
